import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import Raven from 'raven-js';

import schema from '../../schema/index.json';
import configureStore from '../../configureStore';

import { setup } from './actions';

import { reset, cleanUpContent, setReadOnly } from '../../containers/EditorContainer/actions';
import {
  selectEditorBlocks,
  selectEditorIsValid,
} from '../../containers/EditorContainer/selectors';

import EditorContainer from '../../containers/EditorContainer';

import ErrorBoundary from '../../components/ErrorBoundary';

import exportContent from '../../utils/exportContent';

global.App = {};

export class Editor extends React.PureComponent {
  store = configureStore()

  componentDidMount() {
    const definitions = Object.keys(schema.definitions);
    const content = (this.props.defaultContent && JSON.parse(this.props.defaultContent))
      .filter(item => definitions.indexOf(item.type) > -1);

    try {
      this.store.dispatch(setup({
        allowedBlockTypes: this.props.allowedBlockTypes,
        content,
        readOnly: this.props.readOnly,
      }));
    } catch (error) {
      Raven.captureException(error, { extra: this.props });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.readOnly !== this.props.readOnly) {
      this.store.dispatch(setReadOnly(this.props.readOnly));
    }
  }

  getContent = () => {
    // TODO: разобраться, что делать с этим и зачем оно было нужно
    this.store.dispatch(cleanUpContent());

    // TODO: разобраться, что делать с этим и зачем оно было нужно
    // selectChangedMediaItems()(this.store.getState());

    return JSON.stringify(exportContent(selectEditorBlocks()(this.store.getState())));
  }

  isValid = () => {
    // TODO: разобраться, что делать с этим и зачем оно было нужно
    this.store.dispatch(cleanUpContent());

    return selectEditorIsValid()(this.store.getState());
  }

  setContent = (content) => {
    const definitions = Object.keys(schema.definitions);

    try {
      const parsedContent = (content && JSON.parse(content))
        .filter(item => definitions.indexOf(item.type) > -1);

      this.store.dispatch(reset(parsedContent));
    } catch (error) {
      Raven.captureException(error, { extra: content });
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <Provider store={this.store}>
          <EditorContainer postType={this.props.postType} />
        </Provider>
      </ErrorBoundary>
    );
  }
}

Editor.propTypes = {
  allowedBlockTypes: PropTypes.arrayOf(PropTypes.string),
  defaultContent: PropTypes.string,
  readOnly: PropTypes.bool,
  postType: PropTypes.oneOf(['short', 'longread']),
};

Editor.defaultProps = {
  // TODO: сделать пустой массив дефолтным значением
  allowedBlockTypes: undefined,
  defaultContent: '[]',
  readOnly: false,
  postType: undefined,
};

export default Editor;
